import { createStore } from 'redux'

import allreducers from '../reducers/index'

const loadInitialState = () => {
    try {
        const serializedState = localStorage.getItem('reduxState');
        if (!serializedState) return {}; // Return empty state if no data
        return JSON.parse(serializedState);
    } catch (err) {
        console.error('Could not load initial state', err);
        return {}; // Return empty state if error occurs
    }
};
const initialReduxState = loadInitialState();

const store = createStore(allreducers, initialReduxState, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__())

export default store
